import ENVIRONMENT, { Environment } from './environment';
import { AppName, createDebugLogger } from './logging';
const logger = createDebugLogger(AppName.Common);

if (!window.dataLayer) {
  if (ENVIRONMENT !== Environment.Production) {
    logger.log('It seems that window.dataLayer is not initialized. Please make sure GTM is installed properly.');
  }

  window.dataLayer = window.dataLayer || [];
}

export let GtmEvent;

(function (GtmEvent) {
  GtmEvent["UserLoggedIn"] = "user.loggedin";
  GtmEvent["UserLoggedOut"] = "user.loggedout";
  GtmEvent["GoogleLoginFailed"] = "auth.google_login_failed";
  GtmEvent["LocaleChanged"] = "locale.changed";
  GtmEvent["ApplicationStarted"] = "application.started";
  GtmEvent["ApplicationResumed"] = "application.resumed";
  GtmEvent["ApplicationSaved"] = "application.saved";
  GtmEvent["ApplicationPostponed"] = "application.postponed";
  GtmEvent["ApplicationDetailQuotationShown"] = "application.detailed-quote-shown";
  GtmEvent["ApplicationSubmitted"] = "application.submitted";
})(GtmEvent || (GtmEvent = {}));

export const dataLayer = window.dataLayer;